/*
 * @Author: DT
 * @Date: 2022-10-19 09:40:47
 * @LastEditors: DT
 * @LastEditTime: 2022-10-19 15:12:22
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/returnGoods/index.js
 */
// export { default as orderConfirm } from './orderConfirm/orderConfirm.vue';
export const list = (r) =>
  require.ensure([], () => r(require("./list/list.vue")), "list");
export const orderList = (r) =>
  require.ensure(
    [],
    () => r(require("./orderList/orderList.vue")),
    "orderList"
  );
export const pickingList = (r) =>
  require.ensure(
    [],
    () => r(require("./pickingList/pickingList.vue")),
    "pickingList"
  );
export const photoList = (r) =>
  require.ensure(
    [],
    () => r(require("./photoList/photoList.vue")),
    "photoList"
  );
